module.exports = __webpack_public_path__ + "img/UT0374.e97aa37f.png";